"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldRequirementType = void 0;
/**
 * Allows front-end to configure fields as required, optional or hidden
 */
var FieldRequirementType;
(function (FieldRequirementType) {
    FieldRequirementType["REQUIRED"] = "R";
    FieldRequirementType["OPTIONAL"] = "O";
    FieldRequirementType["HIDDEN"] = "H";
})(FieldRequirementType = exports.FieldRequirementType || (exports.FieldRequirementType = {}));
